<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">{{ $route.meta.title }}</div>
              <div class="list-content content tab-content">
                <div
                    class="intro_tab col_6"
                    @click="movePage('content')"
                    :class="{ active: tab === 'content' }"
                >
                  콘텐츠
                </div>
                <div
                    class="intro_tab col_6"
                    @click="movePage('userFix')"
                    :class="{ active: tab === 'userFix' }"
                >
                  고정글 관리
                </div>
              </div>
                <div class="list-content" v-if="tab === 'content'">
                    <board-list-component :boardType="'ktalkContent'"></board-list-component>
                </div>
              <div class="list-content" v-else>
                <board-fix-component
                    :boardType="'ktalkFix'"
                    :createType="'ktalkCreateFix'"
                    :updateType="'ktalkUpdateFix'"
                    :modalType="'ktalkFixModal'"
                ></board-fix-component>
              </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
      <item-one-select-modal></item-one-select-modal>
    </div>
</template>

<script>
import BoardListComponent from "@/components/board/BoardListComponent";
import BoardFixComponent from "@/components/board/BoardFixComponent";
import ItemOneSelectModal from "@/components/modal/ItemOneSelectModal";
export default {
    name: 'KTalkContent',
    mixins: [],
    components: { BoardListComponent, BoardFixComponent,ItemOneSelectModal },
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
          tab: "content",
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
    },
  methods: {
    movePage(url) {
      this.tab = url
    },

  },
    watch: {},
}
</script>
